import { render, staticRenderFns } from "./AddInprogressUsersDialog.vue?vue&type=template&id=05958084&scoped=true"
import script from "./AddInprogressUsersDialog.vue?vue&type=script&lang=ts"
export * from "./AddInprogressUsersDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddInprogressUsersDialog.vue?vue&type=style&index=0&id=05958084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05958084",
  null
  
)

export default component.exports